import { Device, DeviceListParams } from '@repo/user-types'
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

export const getDevices = async ({
  api,
  params,
  config,
}: {
  api: AxiosInstance
  params: DeviceListParams
  config?: Pick<AxiosRequestConfig, 'signal'>
}): Promise<AxiosResponse<Device[]>> => {
  return api.get<Device[]>('/devices', {
    params,
    ...config,
  })
}
